import { ExternalLink } from "lucide-react";
import { businessConfig } from "@/config";

const RUNNING_WILD_LOGO =
  "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/bbbqebql_1.png";

export default function RescueSection() {
  const rescuePhoto = businessConfig.media?.rescueDogPhoto;
  return (
    <section className="rescue-section" id="rescue" data-testid="rescue-section">
      <div className="rescue-section__inner">
        <div className="rescue-section__copy">
          <span className="overline" style={{ color: "var(--pp-gold)" }}>OUR RESCUE PARTNER</span>
          <div className="rescue-section__logo" aria-hidden>
            <img
              src={RUNNING_WILD_LOGO}
              alt="Running Wild Rescue"
              loading="lazy"
              data-testid="rescue-section-logo"
            />
          </div>
          <h2 className="section-h2 text-white">Running Wild Rescue</h2>
          <p className="rescue-section__description">
            For every appointment, every grooming session, every wagging tail —
            we're proud to support a partner who's rescued{" "}
            <strong style={{ color: "var(--pp-gold)" }}>3,400</strong> animals
            since 2018. When you choose Pup's Parlour, you're helping homes get
            found.
          </p>
          <div className="rescue-section__ctas">
            <a
              href="https://runningwildrescue.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="pp-btn-confirm"
              data-testid="rescue-visit-btn"
            >
              Visit Running Wild
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="rescue-section__visual">
          <div
            className={`rescue-section__photo ${rescuePhoto ? "rescue-section__photo--image" : ""}`}
            aria-hidden
          >
            {rescuePhoto ? (
              <img
                src={rescuePhoto}
                alt=""
                loading="lazy"
                className="rescue-section__photo-img"
                data-testid="rescue-section-photo"
              />
            ) : (
              <div className="rescue-section__photo-inner">
                <img
                  src={RUNNING_WILD_LOGO}
                  alt=""
                  loading="lazy"
                  className="rescue-section__photo-logo"
                />
                <span className="rescue-section__photo-caption">rescue dog photo</span>
              </div>
            )}
          </div>
          <div className="rescue-section__stat-card">
            <span className="rescue-section__stat-number">3,429</span>
            <span className="rescue-section__stat-caption">animals rescued since 2018</span>
          </div>
        </div>
      </div>
    </section>
  );
}
